<template>
  <div class="com-search-container">
    <div class="com-search-content">
      <div class="com-search-top">
        <i class="el-icon-close close-icon" @click="cancleDelete"></i>
          搜索查看订单
      </div>
      <el-form class="form-container" @submit.native.prevent>
        <el-form-item class="input-list" label="客户名称" prop="name" v-if="search_type == 1">
          <el-input type="text" placeholder="请输入客户名称回车选择" v-model="name" 
          @keyup.enter.native = "searchIds" style="width:18.5rem"></el-input> 
        </el-form-item>
        <el-form-item class="input-list" style="padding-bottom:0;margin-bottom:0" label="业务人员" prop="name"  v-if="search_type == 2 && user_type == 5">
          <el-input type="text" placeholder="请输入业务人员姓名回车选择" v-model="name" 
          @keyup.enter.native = "searchIds" ></el-input> 
          <el-checkbox v-model="total_order" >全部订单</el-checkbox>
        </el-form-item>
        <el-form-item class="input-list" label="实验室" prop="name" v-if="search_type == 3">
          <el-input type="text" placeholder="请输入委外实验室名称回车选择" v-model="name" 
          @keyup.enter.native = "searchIds" style="width:18.5rem"></el-input> 
        </el-form-item>
        <div class="search-container" v-if="!(search_type == 4 || (user_type == 1 && search_type == 2))">
          <ul class="search-content" v-if = "searchList.length > 0">
            <li
              class="search-list"
              :class="{'search-select': item.id === results.selected_id}"
              v-for="item in searchList"
              :key="item.id"
              @click="searchChoose(item.id)">{{item.name}}</li>
          </ul>
          <div class="none-content" v-else >
            <p class="none-title">请输入搜索条件</p>
          </div>
        </div>
        <el-form-item class="input-list" style="padding-left:4rem; padding-bottom:0; margin-bottom:0" >
          <el-radio v-model="date_span" @change="quickInputDate(3)" label="3" > 近三个月 </el-radio>
          <el-radio v-model="date_span" @change="quickInputDate(6)" label="6" > 近半年 </el-radio>
          <el-radio v-model="date_span" @change="quickInputDate(12)" label="12" > 近一年 </el-radio>
        </el-form-item>
        <el-form-item class="input-list" label="开始日期" prop="cert_date">
          <el-date-picker
            class="date-input"
            type="date"
            v-model="results.start_date"
            value-format="yyyy-MM-dd"
            placeholder="请选择日期"></el-date-picker>
        </el-form-item>        
        <el-form-item class="input-list" label="结束日期" prop="next_date">
          <el-date-picker
            class="date-input"
            type="date"
            v-model="results.end_date"
            value-format="yyyy-MM-dd"
            placeholder="请选择日期"></el-date-picker>
        </el-form-item>        
        <el-form-item class="btn-list" style="margin-top:1rem;margin-bottom:0rem">
          <el-button class="btn-save" @click="searchOrders">搜索订单</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script type='text/ecmascript-6'>
import { getStore, getCookie } from 'common/js/mUtils'
export default {
  props: [
    'search_type',
  ],
  data () {
    return {
      user_type: 0,
      name: '', 
      date_span: 0,
      total_order: false,
      searchList: [],
      results: {orderList:[], total:0, order_sum:0, selected_id: 0, start_date: null, end_date: null}
    }
  },
  created(){
    this.user_type = getStore('user_type')
  },
  methods: {
    cancleDelete () { // 取消删除
      this.$emit('cancelsearch')
      this.$message({
        type: 'info',
        message: '取消搜索！',
        customClass: 'msg-position',
        showClose: true
      })
    },
    quickInputDate(month) {
      var date = new Date(), y = date.getFullYear(), m = date.getMonth();
      this.results.start_date = new Date(y, m - month, 1).toISOString().slice(0,10);
      this.results.end_date = new Date(y, m, 1).toISOString().slice(0,10);
    },
    searchIds() {
      let that = this
      if (that.name) {
        this.$api.searchIds({
          search_type: that.search_type,
          name: that.name
        }).then(res => {
          if (res.data.msg === false) {
            that.$message({
              message: res.data.error,
              type: 'error',
              customClass: 'msg-position',
              showClose: true
            })
            return
          }
          if (res.data.data.length > 0) {
            that.searchList = res.data.data
          } else {
            that.searchList = []
            that.$message({
              message: '没有找到相关信息',
              type: 'error',
              customClass: 'msg-position',
              showClose: true
            })
          }
        }).catch(e => {
          that.$message({
            message: `${e}`,
            type: 'error',
            customClass: 'msg-position',
            showClose: true
          })
        })
      } else {
        that.$message({
          message: '输入不能为空！',
          type: 'error',
          customClass: 'msg-position',
          showClose: true
        })
      }
    },
    searchOrders () { // 输入框的 input 事件
      let that = this
      if (this.user_type == 1 && this.search_type == 2) {
        that.results.selected_id = getCookie('u_uuid_userId')
      }
      if (this.search_type == 4) {
        that.results.selected_id = 1
      }
      if (this.search_type == 2 && this.total_order) {
        that.results.selected_id = -1
      }
      if (that.results.selected_id != 0 && that.results.start_date != null && that.results.end_date != null) {
        this.$api.searchOrders({
          search_type: that.search_type,
          id: that.results.selected_id,
          start_date: that.results.start_date,
          end_date: that.results.end_date,
          page_num: 0
        }).then(res => {
          if (res.data.msg === false) {
            that.$message({
              message: res.data.error,
              type: 'error',
              customClass: 'msg-position',
              showClose: true
            })
            return
          }
          if (res.data.data.detail.length > 0) {
            that.results.orderList = res.data.data.detail
            that.results.order_sum = res.data.data.order_sum
            that.results.total = res.data.data.total
            that.$emit('gotorders',that.results)
          } else {
            that.results.orderList = []
            that.results.order_sum = 0
            that.results.total = 0
            that.$message({
              message: '没有找到符合条件的订单。',
              type: 'error',
              customClass: 'msg-position',
              showClose: true
            })
          }
        }).catch(e => {
          that.$message({
            message: `${e}`,
            type: 'error',
            customClass: 'msg-position',
            showClose: true
          })
        })
      } else {
        that.$message({
          message: '搜索条件不能为空！',
          type: 'error',
          customClass: 'msg-position',
          showClose: true
        })
      }
    },
    searchChoose (id) { // 选择要创建订单的公司
      this.results.selected_id = id
    },
  },
  destroyed () {
  }
}
</script>

<style scoped lang='stylus' rel='stylesheet/stylus'>
.com-search-container
  position:fixed;
  left:0;
  right:0;
  top:0;
  bottom:0;
  background-color:rgba(0, 0, 0, 0.2);
  z-index:10;
  display: flex;
  justify-content: center;
  align-items: center;
  .com-search-content
    background:#fff;
    z-index: 101;
    width: 26rem;
    padding: 0rem;
    border-radius: 0.4rem;
    position: relative;
    overflow:hidden;
    .com-search-top
      line-height: 3rem;
      background: #1D489E;
      color: #fff;
      font-size:0.8rem;
      text-align: center;
      font-weight:bold;
    .form-container
      border: 0;
      padding: 0 2rem 1rem 2rem;
      .input-list
        display: flex;
        margin-top: 1rem;
        &.is-error
          .el-form-item__content
            .el-input
              .el-input__inner
                border: 0.05rem solid #EF757A;
        .el-form-item__label
          color:#474747;
          font-size:0.7rem
          flex: 0 0 5rem;
          text-align: left;
        .el-form-item__content
          position:relative;
          height:2rem;
          flex: 1;
          .el-input
            height:2rem;
            .el-input__inner
              padding: 0 0.8rem;
              border: 0.05rem solid #cfcfcf;
          .el-form-item__error
            /* top:0.5rem; */
            left: 0.8rem;
            background:#fff;
            color:#EF757A;
      .btn-content
        width:100%;
        padding:0;
        margin-top:1rem;
        margin-bottom:0;
        .el-form-item__content
          display: flex;
          width:100%;
          .btn-list
            flex:1;
            height: 2rem;
            &.btn-save
              background:#1D489E;
              span
                color:#fff;
            &.cancle-btn
              background: #cfcfcf;
              color:#fff;
              span
                color:#fff;
      .search-container
        margin: 0 0 0 3.5rem;
        border: 0.05rem solid #cfcfcf;
        max-height: 10rem;
        overflow:hidden;
        .search-content
          overflow-y: auto;
          .search-list
            height: 2rem;
            line-height: 2rem;
            font-size:0.7rem;
            padding: 0 0 0.5rem 0.5rem;
            border-bottom: 0.05rem solid #cfcfcf;
            color: #666;
            &:last-child
              border:0;
            &.search-select
              color: #fff;
              background: #1D489E;
        .none-content
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          margin: 1rem 1rem;
          .none-title
            font-size: 0.7rem;
            color:#666;
    .close-icon
      position: absolute;
      top:0.5rem;
      right:0.5rem;
      color:#fff;
      font-size:1.2rem;
</style>
